import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi'


function About() {
	const {data : {about: {about : {data,name,caption}}}} = useGetSettingQuery()

    return ( 
        <div className="why-choose-section">
			<div className="container">
				<div className="row justify-content-between">
					<div className="col-lg-6">
						<h2 className="section-title">{name}</h2>
						<p>
							{caption}
						</p>

						<div className="row my-5">
							{data.lso_items && data.lso_items.map((row,index) => 
								<div className="col-6 col-md-6" key={index}>
									<div className="feature">
										<div className="icon">
											<img src={row.img_image} alt="" className="imf-fluid"/>
										</div>
										<h3>{row.txt_name}</h3>
										<p>{row.txe_description}</p>
									</div>
								</div>
							)}
						</div>
					</div>

					<div className="col-lg-5">
						<div className="img-wrap">
							<img src={data.img_image} alt="about" className="img-fluid"/>
						</div>
					</div>

				</div>
			</div>
		</div>
    );
}

export default About;